module.exports = __webpack_public_path__ + "static/serviceTesting-519dc7f41f123f679dfe19c9650e6f9e.png";